import { useState, useCallback } from 'react';

export default function useContextMenu() {
    const [menu, setMenu] = useState(null);

    const openMenu = useCallback((event, items) => {
        event.preventDefault();
        event.stopPropagation();
        setMenu({ x: event.clientX, y: event.clientY, items });
    }, []);

    const closeMenu = useCallback(() => {
        setMenu(null);
    }, []);

    return {
        openMenu,
        closeMenu,
        isOpen: !!menu,
        contextMenuProps: menu ? { x: menu.x, y: menu.y, items: menu.items, onClose: closeMenu } : null,
    };
}
